module.exports = __webpack_public_path__ + "4109e54206521278e03086174195a3bb.svg";